// pages/PaginaCoordinadora.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from '../components/images/logo.png';
import { ContenidoDinamico } from '../routes/AppRoutes';

const PaginaCoordinadora = () => {
  const [sessionMenuVisible, setSessionMenuVisible] = useState(false); // Estado para controlar la visibilidad del submenú de "Cerrar sesión"

  // Obtener el nombre completo del alumno desde localStorage
  const nombreMostrar = localStorage.getItem('displayName') || 'Usuario'; // Mostrar el nombre completo del alumno o 'Usuario'

  // Sidebar visible (modo móvil)
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const toggleSidebar = () => setSidebarVisible(v => !v);

  // Submenús abiertos
  const [menusAbiertos, setMenusAbiertos] = useState({
    coordinadora: true,
    catalogos: true
  });
  const toggleSubmenu = (clave) =>
    setMenusAbiertos(prev => ({ ...prev, [clave]: !prev[clave] }));
  const getSubmenuClass = (clave) =>
    menusAbiertos[clave] ? 'submenu-items d-flex flex-column' : 'submenu-items d-none';

  const location = useLocation();
  const navigate = useNavigate();

  // Al entrar a /coordinadora exacto, redirige a /coordinadora/inicio
  // Lógica para verificar que el usuario es una coordinadora (rol 2)
  useEffect(() => {
      const userRole = Number(localStorage.getItem('role'));
      const token = localStorage.getItem('token');

      // Verifica si el rol es el adecuado (coordinadora, por ejemplo, rol 2) y si hay un token de sesión
      if (userRole !== 2 || !token) {
        // Si no es coordinadora o no tiene sesión activa, redirige al login
        navigate('/login', { replace: true });
      }

      // Validar las rutas específicas del coordinadora
      const allowedRoutes = [
        '/coordinadora',                      // Página principal del coordinador
        '/coordinadora/inicio',               // Página de inicio del coordinador
        '/coordinadora/consultar-informacion-coordinadora', // Consultar  y modifica la información del coordinador
        //'/coordinadora/consultar-coordinador', // Consultar la información del coordinador
        '/coordinadora/modificar-coordinador', // Modificar la información del coordinador
        '/coordinadora/registrar-alumnos',    // Registrar nuevos alumnos
        '/coordinadora/modificar-alumnos',    // Modificar información de alumnos
        '/coordinadora/consultar-alumnos',    // Consultar información de los alumnos
        '/coordinadora/registrar-docentes',   // Registrar nuevos docentes
        '/coordinadora/modificar-docentes',   // Modificar información de docentes
        '/coordinadora/consultar-docentes',   // Consultar información de los docentes
        '/coordinadora/registrar-categoria-materias', // Registrar categoría de materias
        '/coordinadora/modificar-categoria', // Modificar categoría de materias
        '/coordinadora/consultar-categoria', // Consultar categoría de materias
        '/coordinadora/registrar-materias',  // Registrar nuevas materias
        '/coordinadora/modificar-materias',  // Modificar materias
        '/coordinadora/consultar-materias',  // Consultar materias
        '/coordinadora/registrar-grupos',    // Registrar nuevos grupos
        '/coordinadora/modificar-grupos',    // Modificar información de los grupos
        '/coordinadora/consultar-grupos',    // Consultar grupos
        '/coordinadora/consultar-planeaciones', // Consultar planeaciones
        '/coordinadora/consultar-evidencias', // Consultar evidencias
        '/coordinadora/consultar-calificaciones', // Consultar calificaciones
        '/coordinadora/consultar-grupos-calificaciones', // Calificaciones por grupo
        '/coordinadora/registrar-calificaciones', // Modificar calificaciones 
        '/coordinadora/consultar-docentehorariogeneral', // Consultar horario del docente
        '/coordinadora/consultar_horario' // Consultar horario
      ];


      if (!allowedRoutes.includes(location.pathname)) {
        // Si la ruta no es una de las permitidas para coordinadora, redirigir al inicio
        navigate('/coordinadora/inicio', { replace: true });
      }

  }, [navigate, location]);

  // Manejo del cierre de sesión
  const handleLogout = () => {
    // Eliminar las credenciales y otros datos del usuario
    localStorage.clear(); // Limpiar localStorage
    // Redirigir al inicio de sesión
    navigate('/login', { replace: true }); // Redirigir al login
  };


  // Cierra sidebar en móvil al navegar
  const onLinkClick = () => {
    if (window.innerWidth < 768) setSidebarVisible(false);
  };
  // Función para alternar la visibilidad del submenú de "Cerrar sesión"
  const toggleSessionMenu = () => {
    setSessionMenuVisible(!sessionMenuVisible);
  };
  

  return (
    <div className="pagina-coordinadora d-flex" style={{ height: '100vh', overflow: 'hidden' }}>
      {/* Botón hamburguesa (solo móvil) */}
      <button className="hamburger-btn d-md-none" onClick={toggleSidebar} aria-label="Abrir menú">
        <i className="fa fa-bars"></i>
      </button>

      {/* SIDEBAR */}
      <aside
        className={`sidebar ${sidebarVisible ? 'active' : ''}`}
        style={{
          zIndex: 1030,
          overflowY: 'auto',
          maxHeight: '100vh'
        }}
      >
        <div className="menu">
          <span className="titulo-left">Plataforma Digital Escolar</span>

          {/* Inicio */}
          <div className="submenu">
            <Link
              to="/coordinadora/inicio"
              className="submenu-btn d-flex align-items-center gap-2"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <i className="fa fa-house"></i>
              <span>Inicio</span>
            </Link>
          </div>

          {/* Coordinadora (SOLO opciones propias) */}
          <button className="submenu-btn">
              <i className="fa fa-user"></i>
              <Link to="/coordinadora/consultar-informacion-coordinadora" style={{ all: 'unset', cursor: 'pointer' }}>
                Consultar Información
              </Link>
          </button>

          {/*<div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('coordinadora')}>
              <i className="fa fa-user-cog"></i> <span>Coordinadora</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('coordinadora')}>
              <Link to="/coordinadora/consultar-informacion-coordinadora" className="submenu-btn" onClick={onLinkClick}>
                <i className="fa fa-search"></i> Consultar su Información
              </Link>
              <Link to="/coordinadora/modificar-coordinador" className="submenu-btn" onClick={onLinkClick}>
                <i className="fa fa-check-circle"></i> Modificar su Información
              </Link>
            </div>
          </div>*/}

          {/* Catálogos (scoped a coordinadora) */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('catalogos')}>
              <i className="fa fa-folder"></i> <span>Catálogos</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>

            <div className={getSubmenuClass('catalogos')}>
              {/* Alumnos */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('alumnos')}>
                  <i className="fa fa-user"></i> <span>Alumnos</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('alumnos')}>
                  <Link to="/coordinadora/registrar-alumnos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Registrar Alumnos
                  </Link>
                  <Link to="/coordinadora/modificar-alumnos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-check-circle"></i> Modificar Alumnos
                  </Link>
                  <Link to="/coordinadora/consultar-alumnos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Alumnos
                  </Link>
                </div>
              </div>

              {/* Docentes */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('docentes')}>
                  <i className="fa fa-chalkboard-teacher"></i> <span>Docentes</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('docentes')}>
                  <Link to="/coordinadora/registrar-docentes" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Registrar Docentes
                  </Link>
                  <Link to="/coordinadora/modificar-docentes" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-check-circle"></i> Modificar Docentes
                  </Link>
                  <Link to="/coordinadora/consultar-docentes" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Docentes
                  </Link>
                </div>
              </div>

              {/* Categoría Materia */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('categoria')}>
                  <i className="fa fa-file-pen"></i> <span>Categoría Materia</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('categoria')}>
                  <Link to="/coordinadora/registrar-categoria-materias" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Registrar Categoría
                  </Link>
                  <Link to="/coordinadora/modificar-categoria" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-check-circle"></i> Modificar Categoría
                  </Link>
                  <Link to="/coordinadora/consultar-categoria" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Categoría
                  </Link>
                </div>
              </div>

              {/* Materias */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('materias')}>
                  <i className="fa fa-book"></i> <span>Materias</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('materias')}>
                  <Link to="/coordinadora/registrar-materias" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Registrar Materias
                  </Link>
                  <Link to="/coordinadora/modificar-materias" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-check-circle"></i> Modificar Materias
                  </Link>
                  <Link to="/coordinadora/consultar-materias" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Materias
                  </Link>
                </div>
              </div>

              {/* Grupos */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('grupos')}>
                  <i className="fa fa-user-group"></i> <span>Grupos</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('grupos')}>
                  <Link to="/coordinadora/registrar-grupos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Registrar Grupos
                  </Link>
                  <Link to="/coordinadora/modificar-grupos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-check-circle"></i> Modificar Grupos
                  </Link>
                  <Link to="/coordinadora/consultar-grupos" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Grupos
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Movimientos (solo lo que aplique a coordinadora) */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('movimientos')}>
              <i className="fa fa-right-left"></i> <span>Movimientos</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('movimientos')}>
              {/* Planeaciones */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('planeaciones')}>
                  <i className="fa fa-book"></i> <span>Planeaciones</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('planeaciones')}>
                  <Link to="/coordinadora/consultar-planeaciones" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Planeaciones
                  </Link>
                  <Link to="/coordinadora/consultar-evidencias" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Evidencias
                  </Link>
                </div>
              </div>

              {/* Calificaciones */}
              <div className="submenu">
                <button className="submenu-btn" onClick={() => toggleSubmenu('calificaciones')}>
                  <i className="fa fa-clipboard-check"></i> <span>Calificaciones</span>
                  <i className="fa fa-chevron-down arrow"></i>
                </button>
                <div className={getSubmenuClass('calificaciones')}>
                  <Link to="/coordinadora/registrar-calificaciones" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-pen"></i> Modificar Calificaciones
                  </Link>
                  <Link to="/coordinadora/consultar-calificaciones" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-search"></i> Consultar Calificaciones
                  </Link>
                  <Link to="/coordinadora/consultar-grupos-calificaciones" className="submenu-btn" onClick={onLinkClick}>
                    <i className="fa fa-table"></i> Calificaciones por Grupo
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* TOPBAR + CONTENIDO */}
      <div className="d-flex flex-column flex-grow-1" style={{ minWidth: 0 }}>
        {/* Topbar */}
        <div className="topbar d-flex justify-content-between align-items-center px-4 py-2">
          <span className="titulo-top d-flex align-items-center">
            <img src={logo} alt="Logo del Instituto" width="30" height="30" className="me-2" />
            Instituto Silviano Carrillo
          </span>

          {/* Submenú sesión */}
          <div className="submenu">
            <button className="submenu-btn btn-sesion" onClick={toggleSessionMenu}>
              <i className="fa fa-user"></i>
              <span>{nombreMostrar}</span> {/* Muestra el nombre completo del alumno */}
              <i className="fa fa-chevron-down arrow"></i>
            </button>

            {/* Submenú con "Cerrar sesión" */}
            {sessionMenuVisible && (
              <div
                style={{
                  display: "block",
                  position: "absolute",
                  top: "100%",       // debajo del botón
                  right: "0",        // alineado a la derecha
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(7, 152, 249, 0.15)",
                  borderRadius: "8px",
                  minWidth: "180px",
                  zIndex: 1000,
                }}
              >
                <button
                  onClick={handleLogout}
                  style={{
                    padding: "10px 16px",
                    color: "#1976d2",
                    border: "none",
                    background: "none",
                    fontSize: "14px",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={e => (e.currentTarget.style.backgroundColor = "#67c6ff")}
                  onMouseOut={e => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <i className="fa fa-right-from-bracket"></i>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            )}

          </div>

        </div>

        {/* Contenido dinámico */}
        <main
          className="contenido-principal flex-grow-1 p-4"
          id="contenido-dinamico"
          style={{ overflowY: 'auto', maxHeight: '100vh' }}
        >
          {/* Fuerza remount al cambiar path o query */}
          <ContenidoDinamico key={location.pathname + location.search} />
        </main>
      </div>
    </div>
  );
};

export default PaginaCoordinadora;
